import { format } from 'date-fns'

/**
 * Calculates start and end dates based on filter type
 * @param {Object} filter - The filter object containing code and numberOfDays
 * @returns {Object} Object containing startDate and endDate strings in ISO format
 */
export const calculateDateRange = (filter) => {
    if (filter.startDate && filter.endDate) {
        return {
            startDate: format(new Date(filter.startDate), 'yyyy-MM-dd'),
            endDate: format(new Date(filter.endDate), 'yyyy-MM-dd'),
        }
    }

    const endDate = new Date()
    const startDate = new Date()

    switch (filter.code) {
        case 'week':
            startDate.setDate(endDate.getDate() - 7)
            break
        case 'month':
            startDate.setDate(endDate.getDate() - 30)
            break
        case '3months':
            startDate.setDate(endDate.getDate() - 91)
            break
        case 'year':
            startDate.setDate(endDate.getDate() - 365)
            break
        default:
            // Fallback to numberOfDays if provided
            if (filter.numberOfDays) {
                startDate.setDate(endDate.getDate() - filter.numberOfDays)
            } else {
                startDate.setDate(endDate.getDate() - 7) // Default to 7 days
            }
    }

    return {
        startDate: format(new Date(startDate), 'yyyy-MM-dd'),
        endDate: format(!!endDate ? new Date(endDate) : new Date(), 'yyyy-MM-dd'),
    }
}

/**
 * Formats date range for API query parameters
 * @param {Object} filter - The filter object
 * @returns {string} Query string parameters for start_date and end_date
 */
export const formatDateRangeForAPI = (filter) => {
    const { startDate, endDate } = calculateDateRange(filter)
    return `start_date=${startDate}&end_date=${endDate}`
}
